import { render } from "./ShorttermTable.vue?vue&type=template&id=12d9a430"
import script from "./ShorttermTable.vue?vue&type=script&lang=js"
export * from "./ShorttermTable.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__